import React from "react";
import { Link } from "react-router-dom";
import { TEMPLATE_LABELS } from "../../../blog/templates/kinds";

// The blog elements' option lists, pure like ./sections so the add dialog and
// the element screens agree on them.
export const collectionOptions = (collections) => () => [
  { value: "", label: "Select a collection" },
  ...(collections || []).map(({ collectionId, title }) => ({
    value: collectionId,
    label: title ? `${title} (${collectionId})` : collectionId,
  })),
];

// Where the template an element renders through is edited. The template is the
// SITE's — one per kind, on the blog's Templates tab — so the element has no
// field for it; this link is what the screen offers instead of the select it
// used to carry. See @common/schema/site/blog.
export const TemplateLink = ({ siteId, kind }) => (
  <p className="mt-3">
    <Link to={`/site/${siteId}/blog/template/${kind}/edit`}>
      Edit the {TEMPLATE_LABELS[kind].toLowerCase()} template
    </Link>
  </p>
);
